import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isCordovaApp } from '@/helpers'
import { useAppStore } from '@/store'
import { routes } from '@/router/routes'


export const useBackButton = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isAuthorized = useAppStore((s) => s.isAuthorized)

  useEffect(() => {
    // Only run this logic in Cordova environment
    if (!isCordovaApp) return

    const onBackKeyDown = (e: Event) => {
      e.preventDefault()

      // React Router v6/v7 maintains the history state.
      // state.idx is the index in the history stack.
      // If idx > 0, we can go back.
      const state = window.history.state

      // Не позволяем авторизованному пользователю аппаратной кнопкой "Назад" вернуться на экран авторизации.
      if (isAuthorized && location.pathname === routes.home) {
        return
      }

      if (isAuthorized && location.pathname.startsWith(routes.auth)) {
        navigate(routes.home, { replace: true })
        return
      }

      if (state && typeof state.idx === 'number' && state.idx > 0) {
        navigate(-1)
      } else {
        // If we are at the root of the history, exit the app
        // @ts-ignore - navigator.app is Cordova specific
        if (navigator.app && navigator.app.exitApp) {
          // @ts-ignore
          navigator.app.exitApp()
        }
      }
    }

    document.addEventListener('backbutton', onBackKeyDown, false)

    return () => {
      document.removeEventListener('backbutton', onBackKeyDown, false)
    }
  }, [ navigate, isAuthorized, location.pathname ])
}
